import { render, staticRenderFns } from "./DmqRegionsModal.vue?vue&type=template&id=d46611c6&"
import script from "./DmqRegionsModal.vue?vue&type=script&lang=ts&"
export * from "./DmqRegionsModal.vue?vue&type=script&lang=ts&"
import style0 from "./DmqRegionsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports